import React from 'react';
import PropTypes from 'prop-types';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
    paper: {
        zIndex: 2,
    },
    menuItem: {
        padding: '.5rem 1rem',
        '&:hover': {
            color: theme.palette.primary.main,
        }
    }
});

class DropdownMenu extends React.Component {
  render() {
    const { anchorEl, classes, items, placement='bottom-start' } = this.props;

    return (
        <Popper open={!!anchorEl} anchorEl={anchorEl} placement={placement} transition disablePortal>
            {({ TransitionProps, placement }) => (
                <Grow
                {...TransitionProps}
                id="menu-list-grow"
                style={{ transformOrigin: 'left top' }}
                >
                    <Paper className={classes.paper}>
                        <MenuList>
                            {items.map((item, i) => (
                                <MenuItem key={i} component='a' href={item.link} className='navbar-item' classes={{root: classes.menuItem}}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </MenuList>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
  }
}

DropdownMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  anchorEl: PropTypes.any,
};

export default withStyles(styles)(DropdownMenu);